// THE VICTORIES: Civ-style, and on the table from the first month
// (DESIGN.md "The Year"). Nothing opens and nobody picks: all four are
// shown with their progress from year 1, the town drifts toward the one
// its game is shaped for, and the campaign ends the moment any is met - by
// the town, or by another people. Pure.
import { VICTORY, RIVAL_LEGACY } from './constants';
import { TECHS } from './cards';

const wonders = (civ) => civ.wonders || [];
const topTier = Math.max(...Object.values(TECHS).map((t) => t.tier));
// Dominion is won by war, not by gifts: a people counts once it has been
// BROKEN (raided down to nothing) and is not hostile now. Gifting both
// neighbours friendly won the bots Dominion in the spring of year 1.
const subdued = (r) => (r.broken || 0) > 0 && r.stance !== 'hostile';

export const VICTORIES = {
  legacy: {
    name: 'Legacy',
    text: `Raise ${VICTORY.legacyWonders} wonders.`,
    progress: (civ) => [wonders(civ).length, VICTORY.legacyWonders],
  },
  dominion: {
    name: 'Dominion',
    text: 'Every people on the island broken by your warbands, and none of them hostile.',
    // Every people, not every people MET: with the victories on from year
    // 1, "the one people we have met is friendly" would end the campaign in
    // the spring of year 1 (a test caught exactly that).
    progress: (civ) => [(civ.rivals || []).filter((r) => r.met && subdued(r)).length, Math.max(1, (civ.rivals || []).length)],
    done: (civ) => (civ.rivals || []).length > 0 && (civ.rivals || []).every((r) => r.met && subdued(r)),
  },
  enlightenment: {
    name: 'Enlightenment',
    text: `Learn ${VICTORY.enlightenTechs} technologies of the last tier (tier ${topTier}).`,
    progress: (civ) => [(civ.techs || []).filter((id) => TECHS[id]?.tier === topTier).length, VICTORY.enlightenTechs],
  },
  prosperity: {
    name: 'Prosperity',
    text: `${VICTORY.prosperPeople} people at ${VICTORY.prosperHappy} happiness for ${VICTORY.prosperNights} nights running.`,
    progress: (civ) => [civ.prosperNights || 0, VICTORY.prosperNights],
  },
};
export const VICTORY_ORDER = Object.keys(VICTORIES);

const met = (civ, id) => {
  const v = VICTORIES[id];
  if (v.done) return v.done(civ);
  const [have, need] = v.progress(civ);
  return have >= need;
};

/** The victory the town has reached, if any. (A save that chose one under the old race still counts every one.) */
export const victoryWon = (civ) => VICTORY_ORDER.find((id) => met(civ, id)) || null;

/** Every victory with how far off it is, for the table. */
export const victoryProgress = (civ) => VICTORY_ORDER.map((id) => {
  const [have, need] = VICTORIES[id].progress(civ);
  return { id, name: VICTORIES[id].name, have, need };
});

/**
 * The other peoples chase Legacy: the wonders they finish are theirs, and a
 * people that finishes RIVAL_LEGACY of them has won the island's memory.
 * Returns the rival that got there, or null.
 */
export const rivalVictor = (civ) => (civ.rivals || []).find((r) => (r.wonders || []).length >= RIVAL_LEGACY) || null;
export const rivalProgress = (civ) => (civ.rivals || []).filter((r) => r.met).map((r) => ({ id: r.id, name: r.name, have: (r.wonders || []).length, need: RIVAL_LEGACY }));

/** Tonight's prosperity streak: grows while the town holds, resets when it slips. */
export const nextProsperNights = (civ) => (
  civ.population >= VICTORY.prosperPeople && civ.happiness >= VICTORY.prosperHappy ? (civ.prosperNights || 0) + 1 : 0
);
